// extracted by mini-css-extract-plugin
export default {"content":"login_content__3hi4X","title":"login_title__Uh-Zy"};